<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-form
        ref="subjectForm"
        :model="formData"
        :rules="rules"
        label-width="140px"
        label-position="left"
        size="mini"
      >
        <h2 class="title mB-30">基本信息</h2>
    
        <el-form-item label="主体名称" prop="subjectName">
          <el-input :disabled="$route.query.type==='1'" v-model="formData.subjectName" placeholder="请输入主体名称"></el-input>
        </el-form-item>

        <h2 class="title">营业执照信息</h2>

        <el-form-item label="营业执照" prop="licensePic">
          <store-img-upload style="display:inline;" v-if="$route.query.type==='2'" type="licensePic" :imgUrls="formData.licensePic" @fileList="(data) => formData.licensePic= data[0]"/>
          <img-upload style="display: inline-block;vertical-align: top;" v-else disabled :fileList="formData.licensePic" @getFileList="(data) => formData.licensePic= data"/>
        </el-form-item>

        <el-form-item label="执照类型" prop="licenseType">
          <el-radio :disabled="$route.query.type==='1'" v-model="formData.licenseType" :label="1">企业</el-radio>
          <el-radio :disabled="$route.query.type==='1'" v-model="formData.licenseType" :label="2">个体工商户</el-radio>
        </el-form-item>

        <el-form-item label="公司名称" prop="corpName">
          <el-input :disabled="$route.query.type==='1'" v-model="formData.corpName" placeholder="请输入公司名称"></el-input>
        </el-form-item>

        <el-form-item label="统一社会信用代码" prop="uniformSocialCreditCode">
          <el-input :disabled="$route.query.type==='1'" v-model.trim="formData.uniformSocialCreditCode" placeholder="请输入统一社会信用代码"></el-input>
        </el-form-item>

        <el-form-item label="注册地址" prop="registerAddress">
          <el-input :disabled="$route.query.type==='1'" v-model.trim="formData.registerAddress" placeholder="请输入注册地址"></el-input>
        </el-form-item>
        
        <el-form-item label="证件有效截止日期" prop="expireType">
          <el-radio :disabled="$route.query.type==='1'" v-model="formData.expireType" :label="1">固定有效日期</el-radio>
          <el-date-picker
            v-model="formData.expireDate"
            :disabled="formData.expireType!== 1 || $route.query.type==='1'"
            v-if="formData.expireType=== 1"
            type="date"
            :picker-options="pickerOptions"
            :default-value="new Date()"
            style="margin-right: 20px;"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择日期" />
          <el-radio v-model="formData.expireType" :label="2">长期有效</el-radio>
        </el-form-item>


        <el-form-item label="纳税性质">
          <el-select :disabled="$route.query.type==='1'" v-model="formData.taxType" placeholder="请选择">
            <el-option label="一般纳税人" value="1"></el-option>
            <el-option label="小规模纳税人" value="2"></el-option>
          </el-select>
        </el-form-item>
        
        <h2 class="title">法人信息</h2>
        <br/>
        <el-form-item label="身份证人像面" prop="idCardPortraitSide">
          <store-img-upload style="display:inline;" v-if="$route.query.type==='2'" type="licensePic" :imgUrls="formData.idCardPortraitSide" @fileList="(data) => formData.idCardPortraitSide= data[0]"/>
          <img-upload style="display: inline-block;vertical-align: top;" v-else disabled :fileList="formData.idCardPortraitSide" @getFileList="(data) => formData.idCardPortraitSide= data"/>
        </el-form-item>

        <el-form-item label="身份证国徽面" prop="idCardEmblemSide">
          <store-img-upload style="display:inline;" v-if="$route.query.type==='2'" type="licensePic" :imgUrls="formData.idCardEmblemSide" @fileList="(data) => formData.idCardEmblemSide= data[0]"/>
          <img-upload style="display: inline-block;vertical-align: top;" v-else disabled :fileList="formData.idCardEmblemSide" @getFileList="(data) => formData.idCardEmblemSide= data"/>
        </el-form-item>


        <el-form-item label="法人姓名" prop="legalPersonName">
          <el-input :disabled="$route.query.type==='1'" v-model.trim="formData.legalPersonName" placeholder="请输入法人姓名"></el-input>
        </el-form-item>
        <el-form-item label="法人身份证号" prop="legalPersonIdCardNo">
          <el-input :disabled="$route.query.type==='1'" v-model.trim="formData.legalPersonIdCardNo" placeholder="请输入法人身份证号"></el-input>
        </el-form-item>
        <el-form-item label="法人实名手机号" prop="legalPersonPhone">
          <el-input :disabled="$route.query.type==='1'" v-model.trim="formData.legalPersonPhone" placeholder="请输入法人实名有效手机号"></el-input>
        </el-form-item>


        <h2 class="title mB-30">银行卡信息</h2>
        <br/>
        <el-form-item label="开户银行" prop="cashBankName">
          <el-input :disabled="true" v-model.trim="formData.cashBankName" ></el-input>
        </el-form-item>
        <el-form-item label="银行卡号" prop="cashAccountCode">
          <el-input :disabled="true" v-model.trim="formData.cashAccountCode" ></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <div v-if="$route.query.type!=='1'" style="display:inline-block;">
          <el-button size="mini" @click="handleBack">取消</el-button>
          <el-button size="mini" type="primary" @click="onSubmit">保存并提交</el-button>
          <el-button type="primary" size="mini" @click="handleOpenAudit">查看审核记录</el-button>
        </div>
        <div v-else>
          <el-button size="mini" @click="handleBack">返回</el-button>
          <el-button type="primary" size="mini" @click="handleOpenAudit">查看审核记录</el-button>
        </div>
        <div>
          <el-dialog :visible.sync="auditVisible">
            <el-table v-loading="loading" :data="tableData">
              <el-table-column label="操作" width="100" align="center" prop="opType"></el-table-column>
              <el-table-column label="操作人" width="100" align="center" prop="operatorName"></el-table-column>
              <el-table-column label="操作时间" align="center" prop="operateTime"></el-table-column>
              <el-table-column label="原因" align="center" prop="reason"></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="closeAuditList">确定</el-button>
            </div>
          </el-dialog>
        </div>   
      </div>
    </basic-container>
  </div>
</template>

<script>

export default {
  data() {
    var checkRegNum = (rules, val, callback) => {
    if(!val) callback(new Error("请输入注册号"))
    else if(val.length> 20) callback(new Error("注册号不得超过20位"))
      callback()
    }
    var checkLisenceName = (rules, val, callback) => {
      if(!val) callback(new Error("请输入营业执照名称"))
      else if(val.length> 32) callback(new Error("营业执照名称不得超过32位"))
      callback()
    };
    var checkLicensePic=  (rules, val, callback)=> {
      const {licensePic}= this.formData
      if(licensePic === "") callback(new Error("请上传营业执照"))
      callback()
    }
    var checkSubjectName = (rules, val, callback) => {
      const {subjectName}= this.formData;
      if (subjectName.length > 30)
        callback(new Error("主体名称不超过30字"));
      if (subjectName.length === 0)
        callback(new Error("主体名称不能为空"));
      callback();
    };
    var checkCardPortrait=  (rules, val, callback)=> {
      const {idCardPortraitSide}= this.formData
      if(idCardPortraitSide === "") callback(new Error("请上传身份证人像面"))
      callback()
    }
    var checkCardEmblem=  (rules, val, callback)=> {
      const {idCardEmblemSide}= this.formData
      if(idCardEmblemSide === "") callback(new Error("请上传身份证国徽面"))
      callback()
    }
    var checkExpireType= (rules, val, callback)=> {
      const {expireType, expireDate}= this.formData
      if(expireType=== 1 && !expireDate) callback(new Error("请选择固定有效日期"))
      callback()
    }
    return {
      subjectId: "",
      formData: {
        id: "",
        subjectName: "",
        groupId: "",
        groupName: "",
        corpName: "",
        licensePic: "",
        licenseType: "",
        uniformSocialCreditCode: "",
        registerAddress: "",
        expireDate: "",
        expireType: "",
        taxType: "",
        idCardPortraitSide: "",
        idCardEmblemSide: "",
        legalPersonName: "",
        legalPersonIdCardNo: "",
        legalPersonPhone: "",
        settlementPeriod: "",
        state: "",
        cashBankName: "",
        cashAccountCode: ""
      },
      tableData: [],
      loading: false,
      auditVisible: false,
      rules: {
        subjectName: [
          {
            required: true,
            validator: checkSubjectName
          }
        ],
        legalPersonName: [
          {
            required: true,
            message: "请输入联系人姓名"
          }
        ],
        legalPersonPhone: [
          {
            required: true,
            message: "请输入联系人电话"
          }
        ],
        legalPersonIdCardNo: [
          {
            required: true,
            message: "请输入法人身份证号"
          }
        ],
        taxType: [
          {
            required: true,
            message: "请选择纳税性质"
          }
        ],
        registerAddress: [
          {
            required: true,
            message: "请填写注册地址"
          }
        ],
        licenseType: [
          {
            required: true,
            message: "请选择营业执照类型"
          }
        ],
        
        corpName: [{required: true, validator: checkLisenceName}],
        uniformSocialCreditCode: [{required: true, validator: checkRegNum}],
        expireType: [{required: true, validator: checkExpireType}],
        licensePic: [{required: true, validator: checkLicensePic}],
        idCardPortraitSide: [{required: true, validator: checkCardPortrait}],
        idCardEmblemSide: [{required: true, validator: checkCardEmblem}],
      },
      echoData: true,
      pickerOptions: {
        disabledDate: (time) => {
          const now = new Date()
          const year = now.getFullYear()
          const month = now.getMonth()
          const day = now.getDate()-1
          return time.getTime() < new Date(year, month, day, 23, 59, 59).getTime()
        }
      },
    };
  },

  created() {
    this.subjectId = this.$route.query.subjectId;
    this.getSubjectDetail();
  },

  beforeRouteEnter(to, from, next) {
    next(async vm => {
      try {
        vm.subjectId = vm.$route.query.subjectId;
        vm.getSubjectDetail();
      } catch (error) {
        console.log(error);
        next();
      }
    })
  },

  beforeRouteLeave(to, from, next) {
    this.$refs.subjectForm.resetFields(); 
    this.$destroy();
    next();
  },

  methods: {
    handleBack() {
      this.$router.go(-1);
    },
    async getSubjectDetail() {
      const {data} = await _api.splitAcc.getSubjectDetail({
        id: this.subjectId
      });
      if (data) {
        this.formData = data;
        this.formData.expireDate *= 1000;
        try {
          if(this.formData.taxType !== null) {
            console.log(this.formData.taxType);
            this.formData.taxType = this.formData.taxType + "";
          }
        } catch (error) {
          console.log(error);
        }
      }
    },


    handleOpenAudit(){
      this.auditVisible=true;
      this.getAuditList();
    },

    closeAuditList(){
      this.auditVisible=false;
    },

    async getAuditList(){
      this.loading=true;
      const{data}=await _api.splitAcc.getVerifySubjectRecord({
        subjectId: this.formData.id
      });
      
      if(data){
        this.tableData=data;
      }
      this.loading=false;
    },

    onSubmit() {
      this.$refs["subjectForm"].validate(val => {
        if (val) {
          this.save();
        } else {
          this.$message({
            type: "warning",
            message: "请完善信息后提交"
          });
        }
      });
    },
    async save() {
      if(this.formData.expireType=== 2) this.formData.expireDate= new Date().getTime()
      this.formData.expireDate/= 1000
      const { ret, data } = await _api.splitAcc.subjectUpdate(this.formData);
      if (ret && data) {
        this.$message({
          type: "success",
          message: "编辑成功"
        });
        this.$router.go(-1);
      }
    }
    
  }
};
</script>
<style scoped>
.el-input {
  width: 300px;
}
.el-textarea {
  width: 400px;
}
.el-select {
  width: 130px;
}
.title {
  font-weight: 900;
  font-size: 16px;
}
</style>
